import type { WebsiteBlock } from '../../types'

interface CustomProps {
  content: string
  html?: string
}

export default function CustomBlock({ block }: { block: WebsiteBlock }) {
  const p = block.props as CustomProps

  const hasContent = p.html?.trim() || p.content?.trim()
  if (!hasContent) return null

  return (
    <section className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="prose prose-sm max-w-none text-gray-600 whitespace-pre-wrap">
          {p.content}
        </div>
      </div>
    </section>
  )
}
